import React from 'react';
import PublicUnitTemplatesRouter from '../containers/PublicUnitTemplatesRouter';

export default (props) => (
  <PublicUnitTemplatesRouter {...props} />
);
